import React, { useState } from 'react';
import { Col, Row } from 'reactstrap';
import { Rating } from 'react-simple-star-rating';

const Answer = ({ index, item, onRating }) => {
  const { question, answer, rating, answerId, questionId } = item;
  const [showRating, setShowRating] = useState(false);
  return (
    <div className="form-horizontal" onMouseEnter={() => setShowRating(true)} onMouseLeave={() => setShowRating(false)}>
      <p className="lead bb" />
      <Row>
        <Col>
          <strong>
            {index + 1}. {question}
          </strong>
          <strong className="float-right">
            <span>
              {(showRating || rating > 0) && (
                <Rating
                  initialValue={rating}
                  size={16}
                  transition
                  onClick={(rate) => onRating(rate, questionId, answerId)}
                />
              )}
            </span>
          </strong>
        </Col>
      </Row>
      <Row>
        <Col>
          <p
            dangerouslySetInnerHTML={{
              __html: answer,
            }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Answer;
